import React, { useRef } from 'react';
import { Input, Row, Col, DatePicker } from 'antd';
import moment from 'moment';

export const CredentialInput = ({
    value={},
    onChange=() => null,
    showKey=true,
    showExpiration=true,
    inputProps={},
    style
}) => {
    const keyInput = useRef(null);
    const expInput = useRef(null);
    const inputStyle = inputProps.style || {};

    const onInputChange = (type, getValue=(e) => e.target.value) =>  (e) => {
        onChange({
            ...value,
            [type]: getValue(e)
        })
    }

    const renderInput = (title, render) => {
        return (
            <Row type="flex" gutter={12}>
                <Col span={6} style={{ textAlign: 'right' }}>
                    {title}
                </Col>
                <Col span={18}>
                    {render}
                </Col>
            </Row>
        )
    }

    return (
        <Row type="flex" style={style}>
            {showKey ? (
                <Col style={{ flex: 1 }}>
                    {renderInput('Key', (
                        <Input
                            {...inputProps}
                            style={{ width: 'auto', ...inputStyle }}
                            ref={keyInput}
                            value={value.key}
                            onChange={onInputChange('key')}
                        />
                    ))}
                </Col>
            ) : null}
            {showExpiration ? (
                <Col style={{ flex: 1 }}>
                    {renderInput('Expiration', (
                        <DatePicker
                            {...inputProps}
                            style={{ width: 'auto', ...inputStyle }}
                            ref={expInput}
                            value={value.expiration && moment(value.expiration)}
                            onChange={onInputChange('expiration', (value) => value.format('YYYY-MM-DD'))}
                            format="YYYY-MM-DD"
                        />
                    ))}
                </Col>
            ) : null}
        </Row>
    )
}